export class NameReplaceService {

    readonly _name_map: { [name: string]: string } = {
        "Ash Nakano": "Ash_Nakano",
        "Kenneth Cable": "stuffalso",
        "William Swiftfoot": "kenku"
    };

    public replace(name: string): string {
        if (Object.keys(this._name_map).includes(name)) {
            return this._name_map[name];
        }

        return name;
    }
}

const _name_replace_service: NameReplaceService = new NameReplaceService();
export default _name_replace_service;